import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Space, Spin } from 'antd';
import Table from '../../../../TableResizable';
import { ColumnsType } from 'antd/es/table';
import ShowFile from '../../../../ShowFile';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import InputForm from '../../../../InputT';

function Tab2(props: { form?: any; garantiesTableau: DataTypeTable[] }) {
  const columns: ColumnsType<DataTypeTable> = [
    { title: 'Code Garantie', dataIndex: 'codgar' },
    { title: 'N° Identification', dataIndex: 'NUMIDENTI' },
    { title: 'Type Garantie', dataIndex: 'typgar' },
    { title: 'Localisation', dataIndex: 'LOCAL' },
    { title: 'Valeur Garantie', dataIndex: 'VALGARANTI' },
    { title: 'Valeur Couvert', dataIndex: 'valCouvert' },
    { title: 'Désignation', dataIndex: 'DESIGNATION' },
    { title: 'Date Début', dataIndex: 'DATDEB' },
    { title: 'Date Fin', dataIndex: 'DATFIN' },
    { title: 'Commentaire', dataIndex: 'TEXTCOMMEN' },
    {
      title: 'Fichier',
      key: 'view',
      render: (_, record) =>
        record.fichier ? (
          <Space size="middle">
            <Tooltip title="Ouvrir le fichier">
              <ShowFile
                file={record.fichier}
                fileName={record.codgar + '-' + record.NUMCLI + '-' + record.DESIGNATION}
              />
            </Tooltip>
          </Space>
        ) : (
          'No file'
        ),
    },
  ];

  return (
    <Spin spinning={false} size="large" style={{ color: 'green' }}>
      <div className="tabItem">
        <Box fontStyle="inherit">
          <Box fontStyle="inherit" className="border-left border" width={'85%'} position={'absolute'}>
            <legend>Garanties de financement</legend>
            <div>
              <Table
                size="small"
                columns={columns}
                pagination={{ pageSize: 5, position: ['bottomRight'] }}
                dataSource={props.garantiesTableau}
              />
            </div>
            <InputForm
              notRequired
              money
              label="Valeur Totale de garantie"
              name="montantGarantieCouvert"
              disabled={true}
              type={'number'}
            />
          </Box>
        </Box>
      </div>
    </Spin>
  );
}

export default Tab2;
